import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export * from './storage';
export * from './requests';
export * from './format';
export * from './convertDateTimeToISO';
export * from './focus';

export function assertNever(x: never): never {
  throw new Error(`Unexpected value: ${x}`);
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getEnumValue<T extends Record<string, string>>(
  enumT: T,
  value: string,
): T[keyof T] | undefined {
  return enumT[value as keyof T];
}
